// Domain constants/enums for the answer-profile resource (relocated from the legacy Model in wave 4.3 ahead of models/ deletion).

export const ACCOUNT_DECLINED_REASON = {
  doNotHave: 'do_not_have',
  doNotWant: 'do_not_want',
  other: 'other',
} as const;
